"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationCompanySupplier',
  data: function data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        cooperationStatus: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      platformOptions: [],
      form: {}
    };
  },
  created: function created() {
    this.loadList();
  },
  methods: {
    statusText: function statusText(v) {
      return {
        pending: '待启用',
        active: '已合作',
        suspended: '已暂停',
        terminated: '已终止'
      }[v] || v;
    },
    actionText: function actionText(v) {
      return {
        activate: '启用',
        suspend: '暂停',
        terminate: '终止'
      }[v] || v;
    },
    loadList: function loadList() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationCompanySupplierListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadList();
    },
    openBind: function openBind() {
      var _this2 = this;
      (0, _decoration.decorationCompanySupplierPlatformOptionsApi)().then(function (list) {
        _this2.platformOptions = list || [];
        _this2.form = {
          supplierId: null,
          paymentTerms: '',
          pricePolicy: '',
          creditLimit: '',
          contactName: '',
          contactPhone: '',
          remark: ''
        };
        _this2.visible = true;
      });
    },
    openEdit: function openEdit(row) {
      this.form = {
        id: row.relation.id,
        supplierId: row.supplierId,
        paymentTerms: row.relation.paymentTerms,
        pricePolicy: row.relation.pricePolicy,
        creditLimit: row.relation.creditLimit,
        contactName: row.relation.contactName || row.contactName,
        contactPhone: row.relation.contactPhone || row.contactPhone,
        remark: row.relation.remark
      };
      this.visible = true;
    },
    submit: function submit() {
      var _this3 = this;
      this.saving = true;
      var req = this.form.id ? (0, _decoration.decorationCompanySupplierUpdateApi)(this.form.id, this.form) : (0, _decoration.decorationCompanySupplierSaveApi)(this.form);
      req.then(function () {
        _this3.$message.success('已保存');
        _this3.visible = false;
        _this3.loadList();
      }).finally(function () {
        _this3.saving = false;
      });
    },
    runAction: function runAction(row, action) {
      var _this4 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationCompanySupplierActionApi)(row.relation.id, {
          action: action
        }).then(function () {
          _this4.$message.success('状态已更新');
          _this4.loadList();
        });
      }).catch(function () {});
    }
  }
};